import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from '../ui/button';
import { Reveal } from '../motion/Reveal';

export const CtaSection = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 bg-gradient-to-r from-cyan-500 via-purple-500 to-yellow-500 text-[#000000]">
      <Reveal className="container mx-auto px-5 md:px-10 text-center">
        <h2 className="heading-4 mb-6 exo2-title-black">
          {t({ sl: 'PRIPRAVLJENI NA ZAČETEK?', en: 'READY TO GET STARTED?', it: 'PRONTI PER INIZIARE?' })}
        </h2>
        <p className="body-large mb-8 max-w-2xl mx-auto">
          {t({
            sl: 'Stopite v stik z nami za brezplačno svetovanje in ponudbo.',
            en: 'Get in touch with us for free consultation and quote.',
            it: 'Contattateci per una consulenza gratuita e un preventivo.'
          })}
        </p>
        <Link to="/contact">
          <Button className="bg-[#000000] text-[white] hover:bg-[#1a1a1a] min-w-[200px] rounded-full px-8 py-6 font-semibold text-base transition-all duration-300 hover:scale-105">
            {t({ sl: 'Kontaktirajte nas', en: 'Contact Us', it: 'Contattaci' })}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </Link>
      </Reveal>
    </section>
  );
};
